export const personalLang = {
    title: {
        'en': 'PERSONAL INFORMATION',
        'fr': 'INFORMATIONS PERSONNELLES',
        'de': 'PERSÖNLICHE INFORMATIONEN',
        'ko': '개인 정보',
        'ch': '个人信息',
        'ru': 'ЛИЧНЫЕ ДАННЫЕ',
        'it': 'INFORMAZIONI PERSONALI',
        'jap': '個人情報',
        'port': 'INFORMAÇÕES PESSOAIS',
        'turk': 'KİŞİSEL BİLGİLER',
        'viet': 'THÔNG TIN CÁ NHÂN',
        'spa': 'INFORMACIÓN PERSONAL',
        'arab': 'معلومات شخصية'
    },
    name: {
        'en': 'Name',
        'fr': 'Prénom',
        'de': 'Name',
        'ko': '이름',
        'ch': '名字',
        'ru': 'Имя',
        'it': 'Nome',
        'jap': '名',
        'port': 'Nome',
        'turk': 'İsim',
        'viet': 'Tên',
        'spa': 'Nombre',
        'arab': 'اسم'
    },
    surname: {
        'en': 'Surname',
        'fr': 'Nom',
        'de': 'Nachname',
        'ko': '성',
        'ch': '姓氏',
        'ru': 'Фамилия',
        'it': 'Cognome',
        'jap': '姓',
        'port': 'Sobrenome',
        'turk': 'Soyisim',
        'viet': 'Họ',
        'spa': 'Apellidos',
        'arab': 'لقب'
    },
    birth: {
        'en': 'Date of birth',
        'fr': 'Date de naissance',
        'de': 'Geburtsdatum',
        'ko': '생년월일',
        'ch': '出生日期',
        'ru': 'Дата рождения',
        'it': 'Data di nascita',
        'jap': '生年月日',
        'port': 'Data de nascimento',
        'turk': 'Doğum Tarihi',
        'viet': 'Ngày sinh',
        'spa': 'Fecha de nacimiento',
        'arab': 'تاريخ الولادة'
    },
    nickname: {
        'en': 'Nickname',
        'fr': 'Pseudo',
        'de': 'Spitzname',
        'ko': '닉네임',
        'ch': '昵称',
        'ru': 'Никнейм',
        'it': 'Soprannome',
        'jap': 'ニックネーム',
        'port': 'Apelido',
        'turk': 'Takma Ad',
        'viet': 'Tên hiệu',
        'spa': 'Nombre de alias',
        'arab': 'الاسم المستعار'
    },
    phone: {
        'en': 'Phone Number',
        'fr': 'Téléphone portable',
        'de': 'Mobile Rufnummer',
        'ko': '휴대전화',
        'ch': '手机号码',
        'ru': 'Номер Телефона',
        'it': 'Numero di Telefono',
        'jap': '電話番号',
        'port': 'Número de telefone',
        'turk': 'Telefon Numarası',
        'viet': 'Số điện thoại',
        'spa': 'N.º de teléfono',
        'arab': 'رقم الهاتف'
    },
    fill_wallet: {
        'en': 'Please fill your BSC wallet (BEP20)!',
        'fr': 'Veuillez remplir votre BSC wallet (BEP20)!',
        'de': 'Bitte füllen Sie Ihre BSC wallet (BEP20)!',
        'ko': '당신의 BSC wallet (BEP20)!',
        'ch': '请填写您的 BSC wallet (BEP20)!',
        'ru': 'Заполните пожалуйста свой BSC wallet (BEP20)!',
        'it': 'Si prega di compilare il BSC wallet (BEP20)!',
        'jap': 'あなたを記入してください BSC wallet (BEP20)!',
        'port': 'Por favor preencha o seu BSC wallet (BEP20)!',
        'turk': 'Lütfen doldurunuz BSC wallet (BEP20)!',
        'viet': 'Xin vui lòng điền vào BSC wallet (BEP20)!',
        'spa': 'Por favor, rellene su BSC wallet (BEP20)!',
        'arab': 'يرجى ملء الخاص بك BSC wallet (BEP20)!'
        
    },
    info: {
        'en': 'By clicking the checkbox, you confirm the correctness of the entered data.',
        'fr': 'En cliquant sur la case à cocher, vous confirmez lexactitude des données saisies.',
        'de': 'Indem Sie auf das Kontrollkästchen klicken, bestätigen Sie die Richtigkeit der eingegebenen Daten.',
        'ko': '체크박스를 클릭하여 입력한 데이터가 정확함을 확인하십시오.',
        'ch': '点击复选框，即表示您确认输入的数据正确。',
        'ru': 'Ставя галочку, Вы подтверждаете правильность введенных данных.',
        'it': 'Cliccando sulla casella, si conferma la correttezza dei dati inseriti.',
        'jap': 'チェックボックスをクリックすることで、入力したデータが正確であることを確認したものとみなされます。',
        'port': 'Ao clicar na caixa de seleção, você confirma a exatidão dos dados inseridos.',
        'turk': 'Bu kutucuğu seçerek girdiğiniz bilgilerin doğru olduğunu teyit etmiş olursunuz.',
        'viet': 'Bằng cách nhấn vào hộp kiểm này, bạn xác nhận tính chính xác của dữ liệu đã nhập.',
        'spa': 'Al hacer clic en la casilla de verificación, confirmas que los datos introducidos son correctos.',
        'arab': 'بالنقر فوق مربع الاختيار، فإنك تؤكد صحة البيانات المدخلة.'
    },
    info2: {
        'en': 'In case of incorrect entries or questions please contact the',
        'fr': 'En cas derreur de saisie ou de question, veuillez nous contacter via',
        'de': 'Bei fehlerhaften Einträgen oder Fragen wenden Sie sich bitte an',
        'ko': '잘못된 항목이나 질문이 있는 경우 로 문의하십시오',
        'ch': '如果输入不正确或有问题，请联系',
        'ru': 'В случае неправильного заполнения или вопросов обращайтесь по адресу',
        'it': 'Nel caso ci siano campi non corretti contatta support@artyfact.game oppure t.me/artyfactsupport.',
        'jap': '入力に誤りがある場合やご質問がありましたら、 support@artyfact.game または t.me/artyfactsupport までお問い合わせください。',
        'port': '入力に誤りがある場合やご質問がありましたら、 support@artyfact.game または t.me/artyfactsupport までお問い合わせください。',
        'turk': 'Girdilerin hatalı olması durumunda, lütfen support@artyfact.game veya t.me/artyfactsupport ile iletişime geçiniz.',
        'viet': 'Girdilerin hatalı olması durumunda, lütfen support@artyfact.game veya t.me/artyfactsupport ile iletişime geçiniz.',
        'spa': 'En caso de entradas incorrectas o preguntas, ponte en contacto escribiendo a support@artyfact.game o en t.me/artyfactsupport.',
        'arab': 'في حالة وجود إدخالات أو أسئلة غير صحيحة ، يرجى الاتصال على support@artyfact.game أو t.me/artyfactsupport.'
    },
    info3: {
        'en': 'or',
        'fr': 'ou',
        'de': 'oder',
        'ko': '또는',
        'ch': '或',
        'ru': 'или',
        'it': 'o',
        'jap': 'または',
        'port': 'ou',
        'turk': 'veya',
        'viet': 'hay',
        'spa': 'o',
        'arab': 'أو'
    },
    success: {
        'en': 'Your data has been successfully saved!',
        'fr': 'Vos données ont été enregistrées avec succès !',
        'de': 'Ihre Daten wurden erfolgreich gespeichert!',
        'ko': '귀하의 데이터가 성공적으로 저장되었습니다!',
        'ch': '您的数据已成功保存！',
        'ru': 'Ваши данные были успешно сохранены!',
        'it': 'I tuoi dati sono stati salvati con successo!',
        'jap': 'データは正常に保存されました！',
        'port': 'Seus dados foram salvos com sucesso!',
        'turk': 'Verileriniz başarıyla kaydedildi!',
        'viet': 'Dữ liệu của bạn đã được lưu lại thành công!',
        'spa': '¡Tus datos se han guardado satisfactoriamente!',
        'arab': 'تم حفظ بياناتك بنجاح!'
    },
    save: {
        'en': 'SAVE',
        'fr': 'ENREGISTRER',
        'de': 'SPEICHERN',
        'ko': '저장',
        'ch': '保存',
        'ru': 'СОХРАНИТЬ',
        'it': 'SALVA',
        'jap': '保存',
        'port': 'SALVAR',
        'turk': 'KAYDET',
        'viet': 'LƯU',
        'spa': 'GUARDAR',
        'arab': 'حفظ'
    },
}